import {
  CopyButtonProps as MantineCopyButtonProps,
  CopyButton as MantineCopyButton,
} from '@mantine/core';

export type CopyButtonProps = MantineCopyButtonProps;

export const CopyButton = MantineCopyButton as typeof MantineCopyButton;

CopyButton.displayName = 'CopyButton';
